import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { MapfreAlertComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { ProfileConfirmModalComponent } from '../../../../dashboard/loggedin-content/profile/profile-confirm-modal/profile-confirm-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { Router, ActivatedRoute, Params, RouterModule } from '@angular/router';
import {
  FormBase,
  FormBaseControlService,
  AlertService,
  GetGooglePlaceService,
  ValidateAddressService,
  ErrorMessageService,
  GTagService,
  AcmicService
} from '@mapfre-design-library/src/public_api';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { BankAccountService } from './../../../../../_services/profile-settings/bank-account.service';
import { ProfileConfirmModalService } from '../../../../../_services/profile-settings/profile-confirm-modal.service';
import { AuthenticationService } from '../../../../../_services/_iam/authentication-service.service';
import { UserDetailsService } from '../../../../../_services/profile-settings/user-details.service';
import { UserDataService } from '../../../../../_services/data-services/user-data.service';
import { ErrorRedirectionService } from '../../../../../_services/error-service/error-redirection.service';
import { FullstateToAbvPipe } from '../../../../../_helpers/_pipes/fullstate-to-abv.pipe';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import * as _ from 'underscore';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ProfileConfirmModalComponent, MapfreAlertComponent, MapfreIputWithValidationComponent, MapfreButtonComponent],
  selector: 'app-checking-account-form',
  templateUrl: './checking-account-form.component.html',
  providers: [FullstateToAbvPipe],
})
export class CheckingAccountFormComponent implements OnInit, OnDestroy {
  @Input() inputs: FormBase<any>[] = [];
  @ViewChild('inputBank') inputBank: any;
  bankinfo;
  changeAddressError: boolean;
  checkingAccountForm: FormGroup;
  confirmModal: boolean;
  mailingAddress: any;
  mailingAddressString: string;
  bankAccountNumber: string;
  confirmBankAccountNumber: string;
  addressAlert: boolean;
  addressInput: string;
  whereInTheProcess: string;
  policyId: string;
  loader = false;
  currentPolicyData: any = [];
  isMailingAddSelected = true;
  isPOBoxAddSelected = false;
  hideZipcodeField = true;
  hideCityStateField = true;
  hideMultipleCityStateField = true;
  cityState = '';
  isZipcodeValid = false;
  hidePoBoxCityStateField = true;
  poBoxCity = '';
  poBoxState = '';
  isPoBoxZipcodeValid = false;
  hidePOMultipleCityStateField = true;
  multipleCityOptionsForPOBox = ['city'];
  multipleCityOptionsForMailing = ['city'];
  accountTypeInput: FormBase<any> = new FormBase<any>({
    key: 'accountType',
    inputType: 'accountType',
    required: true,
  });
  isAcmic: boolean;

  constructor(
    private ipt: FormBaseControlService,
    public router: Router,
    private alertService: AlertService,
    private profileConfirmModalService: ProfileConfirmModalService,
    private bankAccountService: BankAccountService,
    private storageService: StorageServiceObservablesService,
    private getGooglePlaceService: GetGooglePlaceService,
    private authenticationService: AuthenticationService,
    private validateAddressService: ValidateAddressService,
    private userDataService: UserDataService,
    private userDetailsService: UserDetailsService,
    private activatedRoute: ActivatedRoute,
    private errorMessageService: ErrorMessageService,
    private errorRedirectionService: ErrorRedirectionService,
    private fullstateToAbvPipe: FullstateToAbvPipe,
    private policyDataService: PolicyDataService,
    private gTagService: GTagService,
    private translate: TranslateService,
    private acmicService: AcmicService
  ) {
    this.isAcmic = false;
  }

  MatchMaskValue(val) {
    if (
      val.includes('*') ||
      val.includes('**') ||
      val.includes('***') ||
      val.includes('****')
    ) {
      return true;
    } else {
      return false;
    }
  }

  createBankAccountObject() {
    let temAccount = '';
    if (
      this.MatchMaskValue(
        this.checkingAccountForm.controls['bankAccountNumber'].value
      )
    ) {
      temAccount = this.bankAccountNumber;
    } else {
      temAccount = this.checkingAccountForm.controls['bankAccountNumber'].value;
    }

    let bankAccount: any = {};
    if (this.policyId.length === 6) {
      if (this.checkingAccountForm.controls.changeAddressAPT.value) {
        this.mailingAddress.streetName =
          (this.mailingAddress.streetName.includes('|')
            ? this.mailingAddress.streetName.split('|')[0]
            : this.mailingAddress.streetName.split('#')[0]) +
          '#' +
          this.checkingAccountForm.controls.changeAddressAPT.value;
      } else {
        if (this.mailingAddress) {
          this.mailingAddress.streetName = this.mailingAddress
            ? this.mailingAddress.streetName.includes('|')
              ? this.mailingAddress.streetName.split('|')[0]
              : this.mailingAddress.streetName.split('#')[0]
            : '';
        }
      }
      if (this.isPOBoxAddSelected) {
        const formControls = this.checkingAccountForm.controls;
        this.mailingAddress.streetName = `PO box ${formControls.changeAddress_poBox.value}`;
        this.mailingAddress.city = this.poBoxCity;
        this.mailingAddress.state = this.poBoxState;
        this.mailingAddress.zipCode.code =
          formControls.changeAddress_PO_zipCode.value;
      }
    }

    bankAccount = {
      accountHolderName:
        this.checkingAccountForm.controls.bankAccountHolder.value,
      routingNumber: {
        digits:
          this.checkingAccountForm.controls.bankAccountRoutingNumber.value,
      },
      accountNumber: {
        digits: temAccount, // this.bankAccountNumber
      },
      accountType: this.checkingAccountForm.controls['accountType']
        ? this.checkingAccountForm.controls['accountType'].value
        : 'CHECKINGL',
      mailingAddress: this.policyId.length === 10 ? null : this.mailingAddress,
    };
    return bankAccount;
  }

  onCheckDirty() {
    this.profileConfirmModalService.$checkDirty.subscribe((value) => {
      this.confirmModal = value;
    });
    this.profileConfirmModalService.onCheckDirty(this.checkingAccountForm);
    if (this.confirmModal === false) {
      this.router.navigate(['/profile']);
    }
  }

  onBlurAccountnumber() {
    if (
      this.checkingAccountForm.get('bankAccountNumber').value &&
      this.checkingAccountForm.get('bankAccountNumber').value.match(/^[0-9]+$/g)
    ) {
      this.bankAccountNumber =
        this.checkingAccountForm.controls.bankAccountNumber.value;
      this.checkingAccountForm.patchValue({
        bankAccountNumber:
          this.policyId.length === 10
            ? this.bankAccountNumber
            : this.bankAccountNumber
              ? '****' +
              this.bankAccountNumber.substring(
                this.bankAccountNumber.length - 4,
                this.bankAccountNumber.length
              )
              : '',
      });
    }

    if (
      this.checkingAccountForm.get('confirmBankAccountNumber').value &&
      this.checkingAccountForm
        .get('confirmBankAccountNumber')
        .value.match(/^[0-9]+$/g)
    ) {
      this.confirmBankAccountNumber =
        this.checkingAccountForm.controls.confirmBankAccountNumber.value;
      this.checkingAccountForm.patchValue({
        confirmBankAccountNumber:
          this.policyId.length === 10
            ? this.bankAccountNumber
            : this.bankAccountNumber
              ? '****' +
              this.bankAccountNumber.substring(
                this.bankAccountNumber.length - 4,
                this.bankAccountNumber.length
              )
              : '',
      });
    }
  }

  onAccountNumber(ele) {
    if (
      this.checkingAccountForm.get('bankAccountNumber').value &&
      this.checkingAccountForm.get('bankAccountNumber').value.match(/^[0-9]+$/g)
    ) {
      this.bankAccountNumber =
        this.checkingAccountForm.controls.bankAccountNumber.value;
    }

    if (ele.target.id === 'bankAccountNumber') {
      this.checkingAccountForm.patchValue({
        bankAccountNumber: this.bankAccountNumber,
      });
    }

    if (
      this.checkingAccountForm.get('confirmBankAccountNumber').value &&
      this.checkingAccountForm
        .get('confirmBankAccountNumber')
        .value.match(/^[0-9]+$/g)
    ) {
      this.confirmBankAccountNumber =
        this.checkingAccountForm.controls.confirmBankAccountNumber.value;
    }

    if (ele.target.id === 'confirmBankAccountNumber') {
      this.checkingAccountForm.patchValue({
        confirmBankAccountNumber: this.confirmBankAccountNumber,
      });
    }
  }

  onSubmitAccountDetails(action) {
    if (
      this.checkingAccountForm.controls.confirmBankAccountNumber.value !=
      this.checkingAccountForm.controls.bankAccountNumber.value
    ) {
      this.gTagService.triggerFormLink(
        'checkingAccountForm',
        'false',
        this.translate.instant(
          'CHECKING_ACCOUNT_ACCCOUNT_AND_CONFIRM_NUMBER_MATCH'
        )
      );
      this.alertService.error('ACCOUNT_NUMBER_CONFIRM_DO_NOT_MATCH');
      this.checkingAccountForm.controls['bankAccountNumber'].setErrors({
        invalidBankAccNumber: true,
      });
      this.checkingAccountForm.controls['confirmBankAccountNumber'].setErrors({
        invalidConfirmBankAccNumber: true,
      });
    } else {
      this.loader = true;
      const bankAccountDetails = this.createBankAccountObject();
      const email = this.storageService.getUserFromStorage();
      this.bankAccountService
        .addBankAccount(email, bankAccountDetails, this.policyId)
        .subscribe(
          () => {
            this.gTagService.triggerFormLink('checkingAccountForm', 'true', '');
            this.loader = false;
            this.userDetailsService.getUserDetailsByEmail().subscribe();
            if (action === 'add') {
              this.alertService.success('BANK_ACCOUNT_ADDED', true);
            } else {
              this.alertService.success('BANK_ACCOUNT_UPDATED', true);
            }
            this.router.navigate(['/profile']);
          },
          (error) => {
            this.gTagService.triggerFormLink(
              'checkingAccountForm',
              'false',
              this.translate.instant('CHECKING_ACCOUNT_ERROR')
            );
            this.loader = false;
            if (
              error.status === 500 ||
              error.status === 404 ||
              error.status === 403
            ) {
              this.alertService.error(`BANK_ROUTING_NUMBER_VALIDATION`);
            } else {
              this.errorRedirectionService.errorHandler(
                error,
                'ERROR_CHECKING_INFO'
              );
            }
          }
        );
    }
  }

  setCheckingForm() {
    if (this.policyId.length === 10) {
      this.isZipcodeValid = true;
      this.isPoBoxZipcodeValid = true;
    }
    const streetAddress = this.mailingAddress.streetName.includes('|')
      ? this.mailingAddress.streetName.split('|')
      : this.mailingAddress.streetName.split('#');
    const apartment =
      streetAddress && streetAddress.length > 1 ? streetAddress[1] : '';
    this.checkingAccountForm.patchValue({
      changeAddress:
        this.policyId.length !== 10
          ? `${streetAddress[0]}, ${this.mailingAddress.city}, ${this.mailingAddress.stateCode
            ? this.mailingAddress.stateCode
            : this.mailingAddress.state
          }, USA`
          : '',
      changeAddressAPT: this.policyId.length !== 10 ? `${apartment}` : '',
    });
    this.checkingAccountForm.controls.changeAddress.updateValueAndValidity();
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
    });

    this.whereInTheProcess = this.activatedRoute.snapshot.routeConfig.path;
    this.checkingAccountForm = this.ipt.toFormGroup(this.inputs);
    this.checkingAccountForm.addControl(
      'accountType',
      new FormControl('CHECKINGL', [Validators.required])
    );
    this.policyDataService.$policyDetails.subscribe((policyResponse: any) => {
      if (policyResponse) {
        this.currentPolicyData = _.filter(policyResponse, (policy) => {
          return policy.policynumber.policyNumber === this.policyId;
        });
        if (
          this.currentPolicyData.length > 0 &&
          this.currentPolicyData[0].mailingAddress
        ) {
          const address = this.currentPolicyData[0].mailingAddress;
          address.state =
            address.stateCode && address.stateCode !== ''
              ? address.stateCode
              : address.state != undefined
                ? this.fullstateToAbvPipe.transform(address.state)
                : '';
          const FinaladdressStr =
            address.streetName +
            ',' +
            address.city +
            ',' +
            address.state +
            ',' +
            'USA';
          this.validateAddressService.updateAddress(FinaladdressStr);
          this.getGooglePlaceService.updateAddress(address);
          this.getGooglePlaceService.updateAddressAbv(address);
          const mAddress = this.currentPolicyData[0].mailingAddress;
          let street = [];
          street =
            mAddress.streetName != '' && mAddress.streetName != undefined
              ? mAddress.streetName.split('|')
              : mAddress.streetName;
          const streetName = typeof street == 'object' ? street[0] : street;
          this.mailingAddress = this.currentPolicyData[0].mailingAddress;
          this.mailingAddressString = `${streetName}, ${mAddress.city}, ${mAddress.stateCode ? mAddress.stateCode : mAddress.state
            }, USA`;
        }
      }
    });

    this.getGooglePlaceService.$addressAbv.subscribe((address) => {
      if (address) {
        let streetArr = [];
        const m = address;
        streetArr =
          m.streetName != '' && m.streetName != undefined
            ? m.streetName.split('|')
            : m.streetName;
        const streetName =
          typeof streetArr == 'object' ? streetArr[0] : streetArr;
        this.mailingAddress = address;
        if (this.mailingAddress && this.isMailingAddSelected) {
          this.isZipcodeValid = true;
          if (
            address.zipCode.code === 'undefined' ||
            address.zipCode.code === ''
          ) {
            this.isZipcodeValid = false;
            this.hideZipcodeField = false;
          } else {
            this.checkingAccountForm.patchValue({ changeAddress_zipCode: '' });
            this.hideZipcodeField = true;
            this.hideCityStateField = true;
            this.hideMultipleCityStateField = true;
          }
        }
        this.mailingAddressString = `${streetName}, ${m.city}, ${m.stateCode}, USA`;
      }
    });

    this.getGooglePlaceService.$mailingPOBoxAddress.subscribe(
      (addressFields) => {
        if (addressFields) {
          if (
            addressFields.zipcode !== '' &&
            addressFields.city !== '' &&
            addressFields.state !== ''
          ) {
            this.cityState = `${addressFields.city}, ${addressFields.state}`;
            if (this.isPOBoxAddSelected) {
              this.isPoBoxZipcodeValid = true;
              if (Array.isArray(addressFields.city)) {
                this.multipleCityOptionsForPOBox = addressFields.city;
                this.poBoxCity = addressFields.city[0];
                this.hidePoBoxCityStateField = true;
                this.hidePOMultipleCityStateField = false;
                this.checkingAccountForm.patchValue({
                  changeAddress_PO_state: addressFields.state,
                });
              } else {
                this.checkingAccountForm.patchValue({
                  changeAddress_PO_city_state: this.cityState,
                });
                this.poBoxCity = addressFields.city;
                this.hidePOMultipleCityStateField = true;
                this.hidePoBoxCityStateField = false;
              }
              this.poBoxState = addressFields.state;
            } else if (this.isMailingAddSelected) {
              this.isZipcodeValid = true;
              if (Array.isArray(addressFields.city)) {
                this.multipleCityOptionsForMailing = addressFields.city;
                this.mailingAddress.city = addressFields.city[0];
                this.hideCityStateField = true;
                this.hideMultipleCityStateField = false;
                this.checkingAccountForm.patchValue({
                  changeAddress_state: addressFields.state,
                });
              } else {
                this.checkingAccountForm.patchValue({
                  changeAddress_city_state: this.cityState,
                });
                this.mailingAddress.city = addressFields.city;
                this.hideMultipleCityStateField = true;
                this.hideCityStateField = false;
              }
              this.mailingAddress.state = addressFields.state;
              this.mailingAddress.zipCode.code = addressFields.zipcode;
            }
          } else {
            if (this.isPOBoxAddSelected) {
              this.hidePoBoxCityStateField = true;
              this.isPoBoxZipcodeValid = false;
              this.hidePOMultipleCityStateField = true;
            } else if (this.isMailingAddSelected) {
              this.hideCityStateField = true;
              this.hideMultipleCityStateField = true;
              this.isZipcodeValid = false;
            }
          }
        }
      }
    );

    this.userDataService.$userData.subscribe((userData) => {
      if (this.whereInTheProcess === ':policyid/edit-checking-account') {
        if (userData) {
          if (userData.bankAccountDetails) {
            const checkingInfo = userData.bankAccountDetails.filter(
              (x) => x.policyNumber === this.policyId
            );
            if (checkingInfo && checkingInfo.length > 0) {
              if (checkingInfo[0].mailingAddress) {
                const address = checkingInfo[0].mailingAddress;
                address.state =
                  address.stateCode && address.stateCode !== ''
                    ? address.stateCode
                    : address.state != undefined
                      ? this.fullstateToAbvPipe.transform(address.state)
                      : '';
                const FinaladdressStr =
                  address.streetName +
                  ',' +
                  address.city +
                  ',' +
                  address.state +
                  ',' +
                  'USA';
                this.validateAddressService.updateAddress(FinaladdressStr);
                this.getGooglePlaceService.updateAddress(address);
                this.getGooglePlaceService.updateAddressAbv(address);
                const m = checkingInfo[0].mailingAddress;
                let street = [];
                street =
                  m.streetName != '' && m.streetName != undefined
                    ? m.streetName.split('|')
                    : m.streetName;
                const streetName =
                  typeof street == 'object' ? street[0] : street;
                this.mailingAddress = checkingInfo[0].mailingAddress;
                this.mailingAddressString = `${streetName}, ${m.city}, ${m.stateCode}, USA`;
              }
              if (checkingInfo[0].accountType) {
                this.checkingAccountForm.patchValue({ accountType: checkingInfo[0].accountType });
              }
            }
          }
        }
      }
    });

    this.validateAddressService.$address.subscribe((resp) => {
      this.addressInput = resp === undefined ? this.mailingAddressString : resp;
    });
    this.setCheckingForm();
  }

  onCitySelect(event) {
    const selectedCity = event.target.value;
    if (this.isPOBoxAddSelected) {
      this.poBoxCity = selectedCity;
    } else if (this.isMailingAddSelected) {
      this.mailingAddress.city = selectedCity;
    }
  }

  selectAddressType(addressType) {
    const formControls = this.checkingAccountForm.controls;
    if (addressType === 'poBox-address') {
      this.isMailingAddSelected = false;
      this.isPOBoxAddSelected = true;
      formControls.changeAddress_poBox.setValidators([Validators.required]);
      formControls.changeAddress_poBox.updateValueAndValidity();
      formControls.changeAddress.clearValidators();
      formControls.changeAddress.updateValueAndValidity();
    } else if (addressType === 'mailing-address') {
      this.isMailingAddSelected = true;
      this.isPOBoxAddSelected = false;
      formControls.changeAddress.setValidators([Validators.required]);
      formControls.changeAddress.updateValueAndValidity();
      formControls.changeAddress_poBox.clearValidators();
      formControls.changeAddress_poBox.updateValueAndValidity();
    }
  }

  ngOnDestroy() {
    this.getGooglePlaceService.updateMailingPOBoxAdd(undefined);
  }
}
